<template>
	<el-card id="secondary">
		<div class="main clearfloat marginT20">
			<div class="templateBox left">
				<img
					class="phoneImg"
					:src="leftImg"
					alt
				/>
			</div>
			<!-- 箭头块 -->
			<div class="iconBox left">
				<i class="el-icon-right iconRight" style="margin-top: 66px"></i>
				<i class="el-icon-right iconRight" style="margin-top: 270px">
				</i>
			</div>
			<!-- 配置块 -->
			<div class="configBox left">
				<!-- 页面配置 -->
				<el-form
					ref="form"
					size="small"
					:rules="rules"
					:model="form"
					label-width="110px"
				>
					<!-- 浮窗类型 -->
					<el-form-item label="浮窗类型" prop="type">
						<el-select
							class="btnConfigInput"
							v-model="floatType"
							@change="handleTypeChange"
						>
							<el-option
								v-for="item in pageTypes"
								:key="item.value"
								:value="item.value"
								:label="item.label"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="浮窗名称" prop="nvgName">
						<el-input class="btnConfigInput" v-model="form.nvgName"></el-input>
					</el-form-item>
					
				</el-form>
				<Part1 ref='part1' v-if="form.type == 22" :propertes='propertes' :pages='pages' :row='pageInfo.airBtnList'/>
				<Part2 ref='part2' v-if="form.type == 23" :propertes='propertes' :pages='pages' :row='pageInfo'/>
				<Part3 ref='part3' v-if="form.type == 24" :propertes='propertes' :pages='pages' :row='pageInfo'/>
			</div>
		</div>
	</el-card>
</template>

<script>
import Part1 from './part1'
import Part2 from './part2'
import Part3 from './part3'
export default {
	props: ["propertes", "productId", "pageInfo", "pages"],
	components: {
		Part1,
		Part2,
		Part3
	},
	data() {
		return {
			dialogVision: false,
			// 用来当做form表单中type的中介
			floatType: '',
			dialogFlag: "",
			enums: {},
			timeBounds: {},
			form: {
				type: '', // 浮窗类型
				nvgName: '',//浮窗名称
			},
			pageTypes: [
				{
					value: 22,
					label: " 模式选择",
				},
				{
					value: 23,
					label: "定时",
				},
				{
					value: 24,
					label: "滑动设置",
				},
			],
			rules: {
				type: [
					{
						required: true,
						message: "请选择浮窗类型",
						trigger: "blur",
					},
				],
				nvgName: [
					{
						required: true,
						message: "请填写浮窗名称",
						trigger: "blur",
					},
				],
			},
		};
	},
	created() {
		if (this.pageInfo.id) {
			this.form = this.pageInfo
			this.floatType = this.form.type
		} else {
			this.floatType = this.form.type = 22
		}
	},
	computed: {
		leftImg() {
			if (this.form.type == 22) {
				return require('@/assets/imges/standard/airCleaner/airDialog.png')
			} else if (this.form.type == 23){
				return require('@/assets/imges/standard/airCleaner/airDialog1.png')
			} else {
				return require('@/assets/imges/standard/airCleaner/air_detail_slider.png')
			}
		}
	},
	methods: {
		handleTypeChange(newVal) {
			this.$confirm('修改浮窗将删除未保存的模板配置，确认修改吗?', '提示', {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then((val) => {
					// 同意切换页面类型后赋值form.type
					this.form.type = newVal
				}).catch(() => {
					// 如果取消则复原中介值
					this.floatType = this.form.type
				})
		},
		// 提交表单
		handleSubmit() {
			let data
			if (this.form.type == 22) {
				data = this.$refs.part1.handleSubmit()
				return {
					...this.form,
					airBtnList: data
				}
			} else if (this.form.type == 23)  {
				data = this.$refs.part2.handleSubmit()
				return {
					...this.form,
					...data
				}
			} else {
				data = this.$refs.part3.handleSubmit()
				return {
					...this.form,
					...data
				}
			}
		},
	},
};
</script>

<style scoped>
.templateBox {
	width: 280px;
}
.iconRight {
	display: block;
	font-size: 28px;
}

.title {
	font-weight: 500;
	font-size: 14px;
}
.phoneImg {
	width: 280px;
	height: 500px;
}
.configBox {
	border: 1px solid #ccc;
	width: calc(100% - 350px);
	border-radius: 5px;
	padding: 20px;
	min-height: 478px;
}
.btnConfigHeader {
	max-height: 40px;
	vertical-align: bottom;
	font-size: 14px;
}
.btnConfigUpload {
	display: inline-block;
	vertical-align: bottom;
}
.btnConfigInput {
	width: 180px;
}
.btnConfigLong {
	width: calc(100% - 320px);
}
.btnImage {
	margin-left: 10px;
	vertical-align: bottom;
	width: 28px;
	height: 28px;
}
.longInput {
	width: 250px;
}
.checkItem {
	width: 200px;
}
</style>